// پیکربندی اپ کارکنان از متغیرهای Vite (مقادیر پیش‌فرض فقط توسعه محلی؛ keycloak-setup.md §۲.۱).
export interface StaffConfig {
  oidcAuthority: string;
  oidcClientId: string;
  /** خالی ← همان Origin (Proxy توسعه یا Ingress). */
  apiBaseUrl: string;
}

export const staffConfig: StaffConfig = {
  oidcAuthority: import.meta.env.VITE_OIDC_AUTHORITY ?? 'http://localhost:8080/realms/phoenix-staff',
  oidcClientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? 'phoenix-staff-app',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
};

/** نسخه اپ کارکنان (CI مقدار VITE_APP_VERSION را می‌گذارد) — پیوست تیکت پشتیبانی Phoenix (AC-CHN-045.1). */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION ?? '0.1.0';
